import React, { useState } from 'react';
import {
  Alert,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { SysRegRow } from './SysRegRow';
import { ISetting } from '../../Interfaces/ISignature';
import { LoadingSpinner } from '../../core/LoadingSpinner';
import { useGetSettings } from '../../hooks/reactQuerys/SettingQueries';

export const SysRegOverview = () => {
  const { settings, isLoadingSettings } = useGetSettings();

  if (isLoadingSettings) {
    return <LoadingSpinner />;
  }

  if (!settings) {
    return <Alert severity='error'>Zugriff verweigert</Alert>;
  }

  return <SysReg initialSettings={settings} />;
};

type IProps = {
  initialSettings: ISetting[];
};

export const SysReg = ({ initialSettings }: IProps) => {
  const [settings, setSettings] = useState<ISetting[]>(initialSettings);

  return (
    <>
      <Typography variant='h5' sx={{ mt: 5 }}>
        System Registry
      </Typography>

      <Alert severity='warning' sx={{ mt: 2, mb: 5 }}>
        <b>Achtung: System Registry!</b>
        <br />
        Änderungen können das System irreversibel beschädigen!
      </Alert>

      <Table size='small'>
        <TableHead>
          <TableRow>
            <TableCell>Key</TableCell>
            <TableCell>Value</TableCell>
            <TableCell sx={{ width: 100 }}>Aktionen</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {settings.map(x => (
            <SysRegRow
              key={`idSettign-${x.idSetting}`}
              settingObject={x}
              settingArray={settings}
              setSettingArray={setSettings}
            />
          ))}
        </TableBody>
      </Table>
    </>
  );
};
